import { vinnV1Api } from "services/vinn-api-v1";

const vehicleSpecsApi = vinnV1Api.injectEndpoints({
  endpoints: (builder) => ({
    getVehicleSpecs: builder.query({
      query: () => ({
        url: "/pages/vehicle_specs",
      }),
    }),
  }),
});

export const { useGetVehicleSpecsQuery } = vehicleSpecsApi;

// export endpoints for use in SSR
export const { getVehicleSpecs } = vinnV1Api.endpoints;
